import React from 'react';
import { useParams } from 'react-router-dom';
import { useStore } from '../../../../store';
import TopicIntroContent from '../../components/TopicIntroContent';
import { getCivilIcon } from '../../components/CivilIcons';

interface ISection0Props {
  settings: any;
}

const Section0: React.FunctionComponent<ISection0Props> = ({ settings }) => {
  const ID = '1';
  const param = useParams();
  const p_course = param.course || '';
  const p_topic = param['*'] || 'welcome';
  const paragraphSettings = React.useMemo(
    () => settings?.paragraphs?.[0],
    [settings?.paragraphs]
  );
  const { updateParagraphState } = useStore();

  React.useEffect(() => {
    updateParagraphState(p_course, p_topic, ID, 'completed', []);
  }, []);

  return (
    <div className="course-landing">
      <div className="course-landing-content">
        <TopicIntroContent
          title={paragraphSettings?.header}
          icon={getCivilIcon(paragraphSettings?.icon)}
          description={paragraphSettings?.description}
          landingVideo={paragraphSettings?.landingVideo}
          transcripts={paragraphSettings?.transcripts}
          videoId="video-core"
        />
      </div>
    </div>
  );
};

export default Section0;
